export default {
  'prepaidTransactions.title': '充值卡',
  'prepaidTransactions.add.title': '添加新会员',
  'prepaidTransactions.edit.title': '编辑会员',
  'prepaidTransactions.required.desc': '*为必填项',
  'prepaidTransactions.title.records': '条记录',

  'prepaidTransactions.column.created_at': '创建时间',
  'prepaidTransactions.column.name': '名字',
  'prepaidTransactions.column.phone_number': '电话',
  'prepaidTransactions.column.order_number': '订单号',
  'prepaidTransactions.column.card_last_four_digits': '卡号后4位',
  'prepaidTransactions.column.purchase_amount': '充值金额',
  'prepaidTransactions.column.bonus_amount': '充返金额',
  'prepaidTransactions.column.payment_status': '支付状态',
  'prepaidTransactions.payment_status.paid': '已支付',
  'prepaidTransactions.payment_status.authorized': '已授权',
  'prepaidTransactions.payment_status.default': '未知',

  'prepaidTransactions.query.placeholder': '通过名字或者电话号码搜索',
};
